import * as React from 'react';
import { Form, Space } from 'antd';
import FormButtons from './form-buttons';
import { FormProps, Section } from '../../admin-knowledge-base.type';
import { ANIMATION_DURATION, langLabels, languages } from '../../admin-knowledge-base.constants';
import { memo, useEffect, useRef, useState } from 'react';
import TitleField from './title-field';
import { animateForm } from '../../admin-knowledge-base.utils';
import Button from '/react4xp/mixins/ui/button/button';
import { Languages } from '/react4xp/parts/knowledge-base-common/knowledge-base-common.type';

export const SectionForm = memo(({ onSubmit, close, form }: FormProps<Section>) => {
    const [activeLanguage, setActiveLanguage] = useState<Languages>(languages[0]);
    const localizedFieldsRef = useRef<HTMLDivElement>(null);

    const handleLanguageChange = (language: Languages) => {
        setActiveLanguage(language);
        animateForm(localizedFieldsRef.current);
    };

    useEffect(() => {
        setTimeout(() => {
            form.setFieldValue(['draft', 'title'], form.getFieldValue([activeLanguage, 'title']));
        }, ANIMATION_DURATION / 3);
    }, [activeLanguage]);

    return (
        <Form
            form={form}
            onFinish={onSubmit}
            validateTrigger={['onBlur']}
        >
            <Form.Item
                hidden
                name="id"
            />
            <Space.Compact>
                {languages.map((language) => (
                    <Button
                        key={language}
                        onClick={() => handleLanguageChange(language)}
                        color={language === activeLanguage ? 'gold' : ''}
                    >
                        {langLabels[language]}
                    </Button>
                ))}
            </Space.Compact>
            <div ref={localizedFieldsRef}>
                <TitleField
                    activeLanguage={activeLanguage}
                    form={form}
                />
            </div>
            <FormButtons close={close} />
        </Form>
    );
});
